import Vue from "vue";
import i18n from "../../i18n";

import { keyMapper } from "@/utils/formatters";
//import { FUEL_REVERT } from "@/enums/fuel";
import { financialNationalityMap, spanishFinancials } from "@/enums/financials/financialNationality";
import { FINANCIAL_IDS } from "@/enums/financials/financialIds";
import { resolveNotaryTransferFeeValue } from "@/utils/simulation/financialUtils";
import { PUBLIC_POSITIONS } from "@/enums/proposal/publicPositions";

import {
  fetchProposalsByPageOrderBy,
  fetchMixedDropdowns,
  fetchClientTypeDropdown,
  fetchStatesDropdown,
  deleteProposal,
  fetchProposalById,
  fetchBusinessManagersByEntityId,
  saveProposal,
  createProposal,
  fetchSpanishCountries,
  fetchPortugueseCountries,
  fetchNationalityRegime,
  fetchMaritalStatus,
  fetchMarriageTypes,
  fetchResidenceType,
  fetchSickLeaveReason,
  fetchLegalType,
  fetchActivityType,
  fetchStructureType,
  fetchJobCategory,
  fetchJobStatus,
  fetchJobs,
  fetchJobsWithCategory,
  fetchCompanySector,
  submitProposal,
  fetchStreetTypes,
  fetchCae,
  fetchDocumentList,
  deleteDocument,
  fetchDocumentsTypes,
  uploadDocument,
  downloadDocument,
  proposalDigitalSignature,
  getSearchByPostalCode,
  fetchRelationshipList,
  duplicateProposal,
  forfeitProposal,
  fetchIdDocumentTypes,
  fetchEmissionBi,
  credibomDigitalSignature,
  ptDigitalSignature,
  bpiProposalDocDownload,
  fetchIncomeType,
  getSellersBy,
  getProposalLogs,
  fetchCaeByFin,
  videoIdentificationProcess,
} from "../../api/proposals";
import { downloadFile } from "@/utils/documents";

const currentDate = new Date();
const formattedDate = currentDate.toISOString().slice(0, 10);

// Obter a data de 2 anos atrás
const dateFrom = new Date();
dateFrom.setFullYear(currentDate.getFullYear() - 2);
const formattedDateFrom = dateFrom.toISOString().slice(0, 10);

const translationEntityDropdown = {
  ID: "canvasserIdEntity",
  NAME: "canvasserEntityName",
  STREET: "canvasserEntityAddress",
};

const translationBMDropdown = {
  ID: "idBusinessManager",
  NAME: "businessManagerName",
  PHONE: "businessManagerPhone",
  EMAIL: "businessManagerEmail",
};

const clientTypeMapping = {
  Particular: 1,
  "ENI": 2,
  Empresa: 3,
  "Autónomo": 4
};

const translationMapperData = {
  proposalStatus: {
    ID: {
      0: i18n.t("pages.ProposalsPage.proposalsStates.preparation"),
      5: i18n.t("pages.ProposalsPage.proposalsStates.preapproval"),
      10: i18n.t("pages.ProposalsPage.proposalsStates.analysis1"),
      15: i18n.t("pages.ProposalsPage.proposalsStates.analysis2"),
      20: i18n.t("pages.ProposalsPage.proposalsStates.tecnicalRejected"),
      30: i18n.t("pages.ProposalsPage.proposalsStates.conditioned"),
      40: i18n.t("pages.ProposalsPage.proposalsStates.refused"),
      45: i18n.t("pages.ProposalsPage.proposalsStates.canceled"),
      50: i18n.t("pages.ProposalsPage.proposalsStates.aproved"),
      60: i18n.t("pages.ProposalsPage.proposalsStates.contractRequested"),
      70: i18n.t("pages.ProposalsPage.proposalsStates.contractSend1"),
      80: i18n.t("pages.ProposalsPage.proposalsStates.contractSend2"),
      85: i18n.t("pages.ProposalsPage.proposalsStates.activated3"),
      90: i18n.t("pages.ProposalsPage.proposalsStates.activated1"),
      100: i18n.t("pages.ProposalsPage.proposalsStates.activated2"),
    }
  }
}

const getDefaultState = () => {
  return {
    proposalPageKey: 1,
    proposals: [],
    proposal: {},
    totalPages: 0,
    totalResults: 0,
    isTableLoading: false,
    // GSC code
    proposalGSCCode: "0",
    //ID da proposta
    proposalId: 0,
    // Estado da proposta
    proposalStatus: 0,
    //ID da financeira
    proposalFinId: 0,
    //ID do produto
    proposalProdId: 0,
    //is ENI Company
    isENICompany: false,
    //Tipo de cliente
    proposalClientType: {},
    dropdownsFilters: {
      entities: [
        {
          value: -1,
          text: i18n.t("dropdownSelection"),
          disabled: true,
        },
      ],
      products: [
        {
          value: -1,
          text: i18n.t("dropdownSelection"),
          disabled: true,
        },
      ],
      groups: [
        {
          value: -1,
          text: i18n.t("dropdownSelection"),
          disabled: true,
        },
      ],
      financial: [
        {
          value: -1,
          text: i18n.t("dropdownSelection"),
          disabled: true,
        },
      ],
      states: [
        {
          value: -1,
          text: i18n.t("dropdownSelection"),
          disabled: true,
        },
      ],
      clientTypes: [
        {
          value: -1,
          text: i18n.t("dropdownSelection"),
          disabled: true,
        },
      ],
    },
    proposalDropdowns: {
      entities: [
        {
          value: -1,
          text: i18n.t("dropdownSelection"),
          disabled: true,
        },
      ],
      bmByEntity: [
        {
          value: -1,
          text: i18n.t("dropdownSelection"),
          disabled: true,
        },
      ],
      sellersByEntity: [
        {
          value: -1,
          text: i18n.t("dropdownSelection"),
          disabled: true,
        },
      ],
      documentTypes: [{
        value: -1,
        text: i18n.t("dropdownSelection"),
        disabled: true,
      },],
      participantTypesES: [{
        value: -1,
        text: i18n.t("dropdownSelection"),
        disabled: true,
      }, {
        value: 1,
        text: "Titular",
      }, {
        value: 2,
        text: "Cotitular",
      }],
      participantTypesPT: [{
        value: -1,
        text: i18n.t("dropdownSelection"),
        disabled: true,
      }, {
        value: 1,
        text: "Primeiro titular",
      }, {
        value: 2,
        text: "Segundo titular",
      }, {
        value: 3,
        text: "Primeiro Avalista",
      }, {
        value: 4,
        text: "Segundo Avalista",
      }, {
        value: 5,
        text: "Terceiro Avalista",
      }, {
        value: 6,
        text: "Quarto Avalista",
      }],
      dateFirstPayment: [{
        value: -1,
        text: i18n.t("dropdownSelection"),
        disabled: true,
      }, {
        value: "5",
        text: "5",
      }, {
        value: "10",
        text: "10",
      }, {
        value: "15",
        text: "15",
      }, {
        value: "20",
        text: "20",
      }, {
        value: "25",
        text: "25",
      }, {
        value: "Fin de mes",
        text: i18n.t("pages.ProposalsPage.proposalsForm.financialData.financialInfo.label.endOfMonth"),
      }, {
        value: "Dia 1",
        text: i18n.t("pages.ProposalsPage.proposalsForm.financialData.financialInfo.label.firstDay"),
      }]
    },
    proposalFilters: {
      idGroup: "",
      idEntity: "",
      state: "",
      customerType: "",
      filter_search: "",
      dateFrom: formattedDateFrom || "2022-11-01",
      dateTo: formattedDate,
      product: "",
      FIN: "",
    },
    documentsList: [],
    documentTypesArray: [],
    expensesClient: 0,
    proposalEntityId: -1,
    hasCompanyICDoc: false,
    proposalCarBrand: '',
    proposalParticipantPositions: [],
    proposalCotationId: -1,
    showBtnChangeStatus: false,
    showBtnVideoIdentification: true,
    // Cache de países (carregado apenas 1x)
    countriesCache: {
      PT: null,
      ES: null,
    },// ✅ Flag de controle de carregamento
    countriesLoading: {
      PT: false,
      ES: false,
    },
    proposalLegalTaxInvoicedTo: "",
  };
};
const state = getDefaultState();

const getters = {
  getProposal: (state) => state.proposal,
  getProposalsByPage: (state) => state.proposals,
  getProposalGSCCode: (state) => state.proposalGSCCode,
  getIsENICompany: (state) => state.isENICompany,
  getProposalId: (state) => state.proposalId,
  getProposalTable(state) {
    const proposalsRow = state.proposals;
    var proposalRowTable = [];

    proposalRowTable = proposalsRow?.map((item) => {
      return {
        id: item?.id,
        gscCode: item?.gscCode,
        date: item?.date,
        clientName: item?.clientName,
        clientType: item?.clientType,
        financial: item?.financial,
        product: item?.product,
        vehicleInfo: item?.vehicleInfo,
        state: item?.state,
        actionOpenOrRemove: { proposalState: item?.state, proposalId: item?.id },
      };
    }) || [];

    return proposalRowTable;
  },
  getProposalTotalPages: (state) => state.totalPages,
  getProposalTotalResults: (state) => state.totalResults,
  getProposalFilledFilters: (state) =>
    Object.fromEntries(
      Object.entries(state.proposalFilters).filter(([, v]) => {
        return v != "";
      })
    ),
  isTableLoading: (state) => state.isTableLoading,
  getDropdown: (state) => (key) => state.dropdownsFilters[key],
  getProposalFilterByKey: (state) => (key) => state.proposalFilters[key],
  getProposalPageKey: (state) => state.proposalPageKey,
  getEntityDropdown: (state) => state.proposalDropdowns.entities,
  getBMDropdown: (state) => state.proposalDropdowns.bmByEntity,
  getSellersDropdown: (state) => state.proposalDropdowns.sellersByEntity,
  getInterventionType: (state) => (key) => state.proposalDropdowns[key],
  getRelationshipList: (state) => (key) => state.proposalDropdowns[`relationshipList-${key}`],
  getCountryList: (state) => (key) => state.proposalDropdowns[`countryList-${key}`],
  getCountrySimpleList: (state) => (key) => state.proposalDropdowns[`countrySimpleList-${key}`],
  getNationalityRegimeList: (state) => (key) => state.proposalDropdowns[`nationalityRegime-${key}`],
  getEmissionBi: (state) => (key) => state.proposalDropdowns[`emissionBi-${key}`],
  getIdentificationDocumentType: (state) => (key) => state.proposalDropdowns[`identificationDocumentType-${key}`],
  getMaritalStatus: (state) => (key) => state.proposalDropdowns[`maritalStatus-${key}`],
  getMarriageTypes: (state) => (key) => state.proposalDropdowns[`marriageTypes-${key}`],
  getResidenceTypes: (state) => (key) => state.proposalDropdowns[`residenceTypes-${key}`],
  getJobCategory: (state) => (key) => state.proposalDropdowns[`jobCategory-${key}`],
  getJobStatus: (state) => (key) => state.proposalDropdowns[`jobStatus-${key}`],
  getCompanySector: (state) => (key) => state.proposalDropdowns[`companySector-${key}`],
  getJobs: (state) => (key) => state.proposalDropdowns[`jobs-${key}`],
  getJobsWithCategory: (state) => (key) => state.proposalDropdowns[`jobsWithCategory-${key}`],
  getStreetTypes: (state) => (key) => state.proposalDropdowns[`streetTypes-${key}`],
  getSearchByPostalCode: (state) => (key) => state.proposalDropdowns[`locality-${key}`],
  getCAE: (state) => (key) => state.proposalDropdowns[`cae-${key}`],
  getCaeByFin: (state) => (key) => state.proposalDropdowns[`cae-${key}`],
  getLegalType: (state) => (key) => state.proposalDropdowns[`legalType-${key}`],
  getActivityType: (state) => (key) => state.proposalDropdowns[`activityType-${key}`],
  getStructureType: (state) => (key) => state.proposalDropdowns[`structureType-${key}`],
  getSickLeaveReason: (state) => (key) => state.proposalDropdowns[`sickLeaveReason-${key}`],
  getIncomeTypes: (state) => (key) => state.proposalDropdowns[`incomeType-${key}`],
  getNumberOfPayments: (state) => (key) => state.proposalDropdowns[key],
  getResidencePermitTypes: (state) => (key) => state.proposalDropdowns[key],
  getPublicPositionList: (state) => (key) => state.proposalDropdowns[key],
  getDocumentsList: (state) => state.documentsList,
  getDocumentsTypesArray: (state) => state.documentTypesArray,
  getDocumentTypes: (state) => state.proposalDropdowns.documentTypes.slice(0, state.proposalDropdowns.documentTypes.length),
  getParticipantTypes: (state) => {
    // default - é o array de PT's
    let participantTypesArray = state.proposalDropdowns.participantTypesPT;
    const financialId = state.proposalFinId;
    const financialNationality = financialNationalityMap.find((financialInfo) => financialInfo.financialIds.includes(financialId))?.nationality;

    switch (financialNationality) {
      case "ES":
        participantTypesArray = state.proposalDropdowns.participantTypesES;
        break;
      case "PT":
        participantTypesArray = state.proposalDropdowns.participantTypesPT;
        break;
      default:
        break;
    }

    return participantTypesArray;
  },
  getProposalStatus: (state) => state.proposalStatus,
  getProposalFinId: (state) => state.proposalFinId,
  getProposalProdId: (state) => state.proposalProdId,
  getProposalClientType: (state) => state.proposalClientType,
  getIsCompanyClientType: (state) => state.proposalClientType?.clientTypeId === 3,
  getExpensesClient: (state) => state.expensesClient,
  getDateFirstPaymentDropdown: (state) => {
    const financialId = Number(state.proposalFinId);
    if (FINANCIAL_IDS.COFIDIS_PT === financialId || !spanishFinancials.includes(financialId)) {
      return state.proposalDropdowns.dateFirstPayment.filter(option => option.value !== "Fin de mes" && option.value !== "15" && option.value !== "20");
    }
    return state.proposalDropdowns.dateFirstPayment.filter(option => option.value !== "Dia 1");
  },
  getProposalEntityId: (state) => state.proposalEntityId,
  getTHasCompanyICDoc: (state) => state.hasCompanyICDoc,
  getProposalCarBrand: (state) => state.proposalCarBrand,
  getProposalParticipantPositions: (state) => state.proposalParticipantPositions,
  getProposalCotationId: (state) => state.proposalCotationId,
  getPatrimonyValue: (state) => (key) => state.proposalDropdowns[key],
  getIsToShowBtnChangeStatus: (state) => state.showBtnChangeStatus,
  getIsToShowBtnVideoIdentification: (state) => state.showBtnVideoIdentification,
  /**
   * Retorna a lista de países cacheada
   * @param {string} nationality - 'PT' ou 'ES'
  */
  getCountriesCache: (state) => (nationality) => {
    return state.countriesCache[nationality];
  },
  getProposalLegalTaxInvoicedTo: (state) => state.proposalLegalTaxInvoicedTo,
};

const mutations = {
  resetState(state) {
    Object.assign(state, getDefaultState());
  },
  resetProposalDropdownsState(state) {
    state.proposalDropdowns = getDefaultState().proposalDropdowns;
  },
  setProposal(state, proposal) {
    state.proposal = proposal;
  },
  setProposalClientType(state, proposalClientType) {
    state.proposalClientType = proposalClientType;
  },
  setParticipantPositions(state, proposalParticipantPositions) {
    state.proposalParticipantPositions = proposalParticipantPositions;
  },
  setIsENICompany(state, isENICompany) {
    state.isENICompany = isENICompany;
  },
  setProposalPageKey(state) {
    state.proposalPageKey += 1;
  },
  setProposalByPage(state, proposals) {
    state.proposals = proposals;
  },
  setProposalTotalPages(state, totalPages) {
    state.totalPages = totalPages;
  },
  setProposalTotalResults(state, totalResults) {
    state.totalResults = totalResults;
  },
  setProposalId(state, proposalId) {
    state.proposalId = proposalId;
  },
  setTableLoading(state, isTableLoading) {
    state.isTableLoading = isTableLoading;
  },
  setMixedDropdownValues(
    state,
    {
      data,
      stateType = "dropdownsFilters",
      type,
      valueKey = "ID",
      translationMapper = {},
      defaultSelectionKeys = {},
    }
  ) {
    
    var dropdownNeoObj = data.map((item) => {
      const text = type != 'states' ? item?.NAME : (translationMapper?.ID[item?.[valueKey]] || item?.NAME);
      return {
        value: item?.[valueKey],
        text: text,
        ...keyMapper(item, translationMapper),
      };
    });

    dropdownNeoObj = [
      {
        value: -1,
        text: i18n.t("dropdownSelection"),
        disabled: true,
        ...defaultSelectionKeys,
      },
      ...dropdownNeoObj,
    ];

    state[stateType][type] = dropdownNeoObj;
  },
  setCountrySimpleList(
    state,
    {
      data,
      stateType = "dropdownsFilters",
      type,
      textKey = "nameES"
    }
  ) {
    var dropdownNeoObj = data.map((item) => {
      return item?.[textKey];
    });

    state[stateType][type] = dropdownNeoObj;
  },
  setCountryList(
    state,
    {
      data,
      stateType = "dropdownsFilters",
      type,
      valueKey = "id",
      textKey = "nameES"
    }
  ) {
    var dropdownNeoObj = data.map((item) => {
      return {
        value: item?.[valueKey],
        text: item?.[textKey],
      };
    });

    dropdownNeoObj = [
      {
        value: -1,
        text: i18n.t("dropdownSelection"),
        disabled: true,
      },
      ...dropdownNeoObj,
    ];

    state[stateType][type] = dropdownNeoObj;
  },
  setCae(
    state,
    {
      data,
      stateType = "dropdownsFilters",
      type,
      valueKey = "code",
      textKey = "description"
    }
  ) {
    var dropdownNeoObj = data.map((item) => {
      return {
        value: item?.[valueKey],
        text: item?.[valueKey] + " - " + item?.[textKey],
      };
    });

    dropdownNeoObj = [
      {
        value: -1,
        text: i18n.t("dropdownSelection"),
        disabled: true,
      },
      ...dropdownNeoObj,
    ];

    state[stateType][type] = dropdownNeoObj;
  },
  setSimpleFormatDropdown(state,
    {
      data,
      stateType = "dropdownsFilters",
      type,
    }) {
    var dropdownNeoObj = data.map((item, index) => {
      return {
        value: index,
        text: item,
      };
    });

    dropdownNeoObj = [
      {
        value: -1,
        text: i18n.t("dropdownSelection"),
        disabled: true,
      },
      ...dropdownNeoObj,
    ];
    state[stateType][type] = dropdownNeoObj;
  },
  setInterventionTypeByKey(state,
    {
      data,
      stateType,
      fieldKey,
    }) {
    const dropdownOptions = [
      {
        value: -1,
        text: i18n.t("dropdownSelection"),
        disabled: true,
      },
    ];

    // Primeiro Titular - Proposta PT e ES
    if (fieldKey === "interventionType") {
      dropdownOptions.push({
        value: 1,
        text: "Titular",
      });
    } // Particular - Proposta ES
    else if (state.proposalFinId === 12 || state.proposalFinId === 13 || state.proposalFinId === 15) {
      dropdownOptions.push({
        value: 1,
        text: "Cotitular",
      });
    } //Cofidis - Proposta PT - Tipos de intervenção são dinâmicos e vêm da API
    else if (state.proposalFinId === FINANCIAL_IDS.COFIDIS_PT) {
      data?.forEach((item, index) => {
        dropdownOptions.push({
          value: index,
          text: item,
        });
      });
    }
    // Proposta PT Empresa - Apenas Cetelem
    else if (state.proposalClientType?.clientTypeId === 3 && state.proposalFinId === 8) {
      dropdownOptions.push(
        {
          value: 1,
          text: "Avalista",
        }
      );
    }
    // Empresa - Proposta PT
    else if (state.proposalClientType?.clientTypeId === 3) {
      dropdownOptions.push(
        {
          value: 1,
          text: "Titular",
        },
        {
          value: 2,
          text: "Avalista",
        }
      );
    }
    // Particular - Proposta PT
    else {
      dropdownOptions.push(
        {
          value: 1,
          text: "Cotitular",
        },
        {
          value: 2,
          text: "Avalista",
        }
      );
    }

    state[stateType][fieldKey] = dropdownOptions;
  },
  setNumberOfPayments(state,
    {
      stateType,
      fieldKey,
    }) {
    const dropdownNeoObj = [
      {
        value: 0,
        text: "0",
      },
      {
        value: 12,
        text: "12",
      },
      {
        value: 14,
        text: "14",
      }
    ];

    state[stateType][fieldKey] = dropdownNeoObj;
  },
  setPatrimonyValue(state,
    {
      stateType,
      fieldKey,
    }) {
    const dropdownNeoObj = [
      {
        value: "",
        text: i18n.t("dropdownSelection"),
        disabled: true,
      },
      {
        value: "500.000",
        text: "Até 500.000",
      },
      {
        value: "Entre 500.000 e 1.0000 ",
        text: "Entre 500.000 e 1.0000 ",
      },
      {
        value: "Mais que 1.0000",
        text: "Mais que 1.0000",
      }
    ];

    state[stateType][fieldKey] = dropdownNeoObj;
  },
  setResidencePermitTypes(state,
    {
      stateType,
      fieldKey,
    }) {
    const dropdownNeoObj = [
      {
        value: "",
        text: i18n.t('dropdownSelection'),
        disabled: true,
      },
      {
        value: "Temporario",
        text: "Temporario",
      },
      {
        value: "Permanente",
        text: "Permanente",
      }
    ];

    state[stateType][fieldKey] = dropdownNeoObj;
  },
  setPublicPositionList(state, { stateType, fieldKey, data }) {
    const items = data && data.length ? data : PUBLIC_POSITIONS;
    const dropdownNeoObj = [
      {
        value: "",
        text: i18n.t('dropdownSelection'),
        disabled: true,
      },
      ...items,
    ];
    state[stateType][fieldKey] = dropdownNeoObj;
  },
  setProposalFilterByKey(state, filter) {
    state.proposalFilters[filter.key] = filter.value;
  },
  setProposalFilters(state, filters) {
    state.proposalFilters = filters;
  },
  setProposalGSCCode(state, proposalGSCCode) {
    state.proposalGSCCode = proposalGSCCode;
  },
  setProposalCotationId(state, proposalCotationId) {
    state.proposalCotationId = proposalCotationId;
  },
  setDocumentTypesArray(state, documentTypesArray) {
    state.documentTypesArray = documentTypesArray;
  },
  setDocumentTypesDropdown(state,
    {
      data,
      stateType = "proposalDropdowns",
      type
    }) {
    var dropdownNeoObj = data.map((item) => {
      return {
        value: item?.id,
        text: item?.name,
      };
    });

    dropdownNeoObj = [
      {
        value: -1,
        text: i18n.t("dropdownSelection"),
        disabled: true,
      },
      ...dropdownNeoObj,
    ];
    state[stateType][type] = dropdownNeoObj;
  },
  setDocumentsList(state, documentsList) {
    var neoDocumentsList = documentsList?.map((item) => {
      return {
        id: item?.idProposalDocumentationType,
        name: item?.filename,
        size: "000",
        base64: "",
        type: item.proposalDocumentationType,
        intervenant: item.clientInterventionType,
        dtCreated: item?.dtUpdate,
        status: { existsStatus: item?.existsStatus, statusCode: item?.statusCode },
        date: item?.dtUpdate,
        comment: item?.comment,
      };
    });
    state.documentsList = neoDocumentsList;
  },
  setProposalStatus(state, proposalStatus) {
    state.proposalStatus = proposalStatus;
  },
  setProposalFinId(state, proposalFinId) {
    state.proposalFinId = proposalFinId;
  },
  setProposalProdId(state, proposalProdId) {
    state.proposalProdId = proposalProdId;
  },
  setProposalEntityId(state, proposalEntityId) {
    state.proposalEntityId = proposalEntityId;
  },
  setProposalCarBrand(state, proposalCarBrand) {
    state.proposalCarBrand = proposalCarBrand;
  },
  setHasCompanyICDoc(state, hasCompanyICDoc) {
    state.hasCompanyICDoc = hasCompanyICDoc;
  },
  setShowBtnChangeStatus(state, isToShowBtnChangeStatus) {
    state.showBtnChangeStatus = isToShowBtnChangeStatus;
  },
  setShowBtnVideoIdentification(state, isToShowBtnVideoIdentification) {
    state.showBtnVideoIdentification = isToShowBtnVideoIdentification;
  },
  setPostalCodeFormatDropdown(state,
    {
      data,
      stateType = "proposalDropdowns",
      localityType,
    }) {
    var dropdownNeoObj = data?.locality?.map((item, index) => {
      return {
        value: index,
        text: item,
      };
    }) || [];

    dropdownNeoObj = [
      {
        value: -1,
        text: i18n.t("dropdownSelection"),
        disabled: true,
      },
      ...dropdownNeoObj,
    ];
    state[stateType][localityType] = dropdownNeoObj;
  },
  setExpensesClient(state, expensesClient) {
    state.expensesClient = expensesClient;
  },
  /**
   * Armazena países no cache
  */
  setCountriesCache(state, { nationality, data }) {
    state.countriesCache[nationality] = data;
  },
  setProposalLegalTaxInvoicedTo(state, proposalLegalTaxInvoicedTo) {
    state.proposalLegalTaxInvoicedTo = proposalLegalTaxInvoicedTo;
  },

};

const actions = {
  resetCotationState({ commit }) {
    commit("resetState");
  },
  async getProposalByPageOrderBy({ commit, rootGetters }, page) {
    commit("setTableLoading", true);
    try {
      const idInstance = rootGetters["AuthenticationModule/getUserInstanceId"] || -1;
      const idEntity = (page?.entityId && page?.entityId != 'undefined') ? page?.entityId : -1;
      const response = await fetchProposalsByPageOrderBy(
        page.page,
        page.orderBy,
        page?.search,
        page?.pageSize,
        idEntity,
        idInstance
      );
      commit("setProposalByPage", response?.data?.data);
      commit("setProposalTotalPages", response?.data?.pages);
      commit("setProposalTotalResults", response?.data?.total);
    } catch (error) {
      console.log(error);
    } finally {
      commit("setTableLoading", false);
    }
  },
  async getMixedFiltersDropdown({ commit, rootGetters }) {
    try {
      const idInstance = rootGetters["AuthenticationModule/getUserInstanceId"] || -1;
      const responseMixed = await fetchMixedDropdowns({ idInstance });
      commit("setMixedDropdownValues", {
        data: responseMixed?.data?.data?.entities,
        type: "entities",
      });
      commit("setMixedDropdownValues", {
        data: responseMixed?.data?.data?.products,
        type: "products",
      });
      commit("setMixedDropdownValues", {
        data: responseMixed?.data?.data?.groups,
        type: "groups",
      });
      commit("setMixedDropdownValues", {
        data: responseMixed?.data?.data?.financial,
        type: "financial",
      });

      const responseClientType = await fetchClientTypeDropdown();
      commit("setMixedDropdownValues", {
        data: responseClientType?.data?.data,
        type: "clientTypes",
      });

      const responseStates = await fetchStatesDropdown();
      commit("setMixedDropdownValues", {
        data: responseStates?.data?.data,
        type: "states",
        translationMapper: translationMapperData?.proposalStatus,
      });
    } catch (error) {
      console.log(error);
    }
  },
  async deleteProposal({ commit }, payload) {
    commit("setTableLoading", false);
    try {
      const response = await deleteProposal(payload);
      console.log(response);
    } catch (error) {
      console.log(error);
    }
  },
  async getProposalById({ commit }, id) {
    commit("setTableLoading", false);
    try {
      const response = await fetchProposalById(id);

      const customerTypeLabel = response?.data?.data?.proposal?.customerType;

      commit("setProposalGSCCode", response?.data?.data?.proposal?.identification?.GSCCode);
      commit("setProposalCotationId", response?.data?.data?.proposal?.identification?.idCotation ?? -1);
      commit("setIsENICompany", response?.data?.data?.proposal?.isENICompany);
      commit("setProposalClientType", {
        clientTypeId: clientTypeMapping[customerTypeLabel],
        clientType: customerTypeLabel
      });

      commit("setProposal", response?.data?.data?.proposal);
      commit("setParticipantPositions", response?.data?.data?.proposal?.lstparticipantPosition);

      commit("setProposalLegalTaxInvoicedTo", response?.data?.data?.proposal?.financialData?.legalTaxInvoicedTo || "");

      return response;
    } catch (error) {
      console.log(error);
    }
  },
  async getEntityDropdown({ commit, rootGetters }) {
    try {
      const idInstance = rootGetters["AuthenticationModule/getUserInstanceId"] || -1;
      const responseMixed = await fetchMixedDropdowns({ idInstance });
      commit("setMixedDropdownValues", {
        data: responseMixed?.data?.data?.entities,
        type: "entities",
        stateType: "proposalDropdowns",
        valueKey: "NAME",
        translationMapper: translationEntityDropdown,
        defaultSelectionKeys: {
          canvasserIdEntity: "",
          canvasserEntityAddress: "",
        },
      });
    } catch (error) {
      console.log(error);
    }
  },
  async getBMDropdown({ commit, rootGetters }) {
    try {
      const entityId = rootGetters["AuthenticationModule/getUserEntityId"];
      const idInstance = rootGetters["AuthenticationModule/getUserInstanceId"] || -1;
      const responseMixed = await fetchBusinessManagersByEntityId(idInstance, entityId);
      commit("setMixedDropdownValues", {
        data: responseMixed?.data?.data,
        type: "bmByEntity",
        stateType: "proposalDropdowns",
        valueKey: "NAME",
        translationMapper: translationBMDropdown,
        defaultSelectionKeys: {
          idBusinessManager: "",
          businessManagerPhone: "",
          businessManagerEmail: "",
        },
      });
    } catch (error) {
      console.log(error);
    }
  },
  async getSellersDropdown({ commit, rootGetters }) {
    try {
      const entityId = rootGetters["AuthenticationModule/getUserEntityId"];
      const responseMixed = await getSellersBy(entityId);
      commit("setMixedDropdownValues", {
        data: responseMixed?.data?.data,
        type: "sellersByEntity",
        stateType: "proposalDropdowns",
        valueKey: "NAME",
        translationMapper: translationBMDropdown,
        defaultSelectionKeys: {
          idBusinessManager: "",
          businessManagerPhone: "",
          businessManagerEmail: "",
        },
      });
    } catch (error) {
      console.log(error);
    }
  },
  async saveProposalTab({ commit }, payload) {
    commit("setTableLoading", false);
    console.log("IN SAVE PROPOSAL TAB");

    try {
      const response = await saveProposal(payload);
      
      const { status, data } = response?.response || response;
      
      commit("setParticipantPositions", data?.data?.lstparticipantPosition);
      Vue.$toast.open({
        message:
          status == 200 ? i18n.t("form.success.save") : data?.message || data?.data || data,
        dismissible: true,
        type: status == 200 ? "success" : "error",
      });
    } catch (error) {
      console.log('error: ', error);
      Vue.$toast.open({
        message: i18n.t("form.error.generic"),
        dismissible: true,
        type: "error",
      });
    }
  },
  async createProposal({ commit, rootState }, simulationState) {
    commit("setTableLoading", false);
    console.log("CREATE PROPOSAL");

    const instalationId =
      rootState.AuthenticationModule.instalationsDropdown.find(
        (item) => item.selected
      )?.value;
    const selectedEntity = rootState.AuthenticationModule.rawInstalations.find(
      item => Number(item.ID) === Number(instalationId)
    );

    const idSelFinancial = simulationState.financingInfo.selectedFin?.value;
    const idProduct = simulationState.financingInfo.selectedProd?.value;

    const ppc = simulationState.financingInfo.ppcValue;
    const ppcNumber = simulationState.financingInfo.ppcNrValue;

    const isBBVASpain = simulationState.bbvaSpain;

    simulationState.financingInfo.withFinancedExpenses = isBBVASpain
      ? { id: 1, value: i18n.t("pages.SimulatorPage.financingInfo.withFinancedExpenses.yes") }
      : simulationState.financingInfo?.withFinancedExpenses;

    const legalTaxInvoicedTo = resolveNotaryTransferFeeValue(
      idSelFinancial,
      simulationState.financingInfo?.notaryTransferFeesBillTheValue?.value,
      selectedEntity?.ID_ENTITYCOMPANY
    );

    try {
      const payload = {
        "financial": idSelFinancial,
        "entity": instalationId,
        "idCotation": simulationState.idCotation ?? -1,
        "financialInfo": {
          "idProduct": idProduct,
          "periodicity": simulationState.financingInfo?.periodicity?.id === 1 ? "Mensal" : "Trimestral",
          "rateType": simulationState.financingInfo?.interestRate?.id === 1 ? "Fixa" : "Indexada",
          "expensesFinance": simulationState.financingInfo?.withFinancedExpenses.id === 1
            ? "S"
            : "N",
          "taxstampFinance": simulationState.financingInfo?.withFinancedTax.id === 1
            ? "S"
            : "N",
          "pvp": Number(simulationState.financingInfo?.pvp),
          "maintenanceContract": 0,
          "warrantyExtra": 0,
          "rate": Number(simulationState.financingInfo?.rate),
          "initialValueEur": Number(simulationState.financingInfo?.initialEntry),
          "capitalFinanciado": Number(simulationState.simulationResults?.capitalToFinance),
          "nrPayments": Number(simulationState.financingInfo?.period),
          "residualValueEur": simulationState.financingInfo?.residualValue === ""
            ? 0
            : Number(simulationState.financingInfo?.residualValue),
          "prestacao": Number(simulationState.simulationResults?.fee),
          "comCaucao": simulationState.financingInfo?.withBail.id === 1
            ? "S"
            : "N",
          "caucao": Number(simulationState.simulationResults?.guarantee),
          //"expenses": Number(simulationState.simulationResults?.initialExpenses),
          "expenses": idSelFinancial === FINANCIAL_IDS.CAIXABANK ? Number(state.simulationResults?.initialExpenses) : Number(state.financingInfo?.expenses),
          "valorSelo": Number(simulationState.simulationResults?.taxStamp),
          "portsExpenses": Number(simulationState.simulationResults?.portsExpenses),
          "taeg": Number(simulationState.simulationResults?.taeg),
          "firstpayment": Number(simulationState.simulationResults?.firstPayment),
          "ppc": ppc.value === -1 ? "" : ppc.text,
          "ppcValue": Number(simulationState.simulationResults?.singlePPCValue),
          "insurancePPCnrInsuredPeople": ppcNumber.value === -1 ? 0 : Number(ppcNumber.text),
          "rewardFinancial": Number(simulationState.simulationResults?.rewardFinancial),
          "rewardFinancialDealer": 0,
          "rewardExpenses": Number(simulationState.simulationResults?.rewardInitialExpenses),
          "rewardPPC": Number(simulationState.simulationResults?.PPCReward),
          "rewardIncrementalMonth1": Number(simulationState.simulationResults?.rewardIncrementalMonth1),
          "rewardIncrementalMonth2": Number(simulationState.simulationResults?.rewardIncrementalMonth1),
          "lackperiod": 0,
          "differentialFeeNrMonths": 0,
          "differentialFeeValue": 0,
          "legalTaxInvoicedTo": legalTaxInvoicedTo,
        },
        "carInfo": {
          "carType": simulationState.vehicleInfo.vehicleCondition?.id === 1
            ? "Novo"
            : "Usado",
          "carYear": simulationState.vehicleInfo?.plateYear?.value === -1
            ? 0
            : Number(simulationState.vehicleInfo?.plateYear?.text),
          "carMonth": simulationState.vehicleInfo?.plateMonth?.value === -1
            ? 0
            : Number(simulationState.vehicleInfo?.plateMonth?.text),
          "carDay": simulationState.vehicleInfo?.plateDay?.value === -1
            ? 1
            : Number(simulationState.vehicleInfo?.plateDay?.text),
          "category": simulationState.vehicleInfo?.vehicleType,
          "brand": simulationState.vehicleInfo?.brand,
          "model": simulationState.vehicleInfo?.modelExt || simulationState.vehicleInfo?.model,
          "version": simulationState.vehicleInfo?.version !== "" ? simulationState.vehicleInfo?.version.split("|")[0] : simulationState.vehicleInfo?.version,
          "tylacode": simulationState.vehicleInfo?.euroTaxCode,
          "grossWeight": simulationState.vehicleInfo?.grossWeight,
          "fuelType": simulationState.vehicleInfo?.fuel,
          "hp": simulationState.vehicleInfo?.enginePower,
          "displacement": simulationState.vehicleInfo?.displacementEngine,
          "nrDoors": Number(simulationState.vehicleInfo?.doors),
          "seats": Number(simulationState.vehicleInfo?.places)
        },
        "clientInfo": {
          "clientType": simulationState.clientInfo?.clientType,
          "firstENIType": simulationState.clientInfo?.clientType === 1 ? "Particular" : simulationState.clientInfo?.clientType === 2 ? "ENI" : simulationState.clientInfo?.clientType === 3 ? "Empresa" : "Autónomo",
          "clientFirstName": simulationState.clientInfo?.firstName,
          "clientFirstSurname": simulationState.clientInfo?.firstSurname,
          "clientSecondSurname": simulationState.clientInfo?.secondSurname,
          "clientBirthdate": simulationState.clientInfo?.birthdate ? simulationState.clientInfo?.birthdate : null,
          "clientPhone": simulationState.clientInfo?.phoneNumber,
          "clientEmail": simulationState.clientInfo?.email,
          "clientObs": simulationState.clientInfo?.notes,
          "salesman": simulationState.sellerInfo?.seller,
          "emailSalesman": simulationState.sellerInfo?.emailSeller,
          "isENICompany": simulationState.clientInfo?.isENICompany
        }
      };

      const { status, data } = await createProposal(payload);
      Vue.$toast.open({
        message:
          status == 200 ? i18n.t("pages.SimulatorPage.simulationError.toProposalSuccess.success") : data.message,
        dismissible: true,
        type: "success",
      });
      return data?.data;
    } catch (error) {
      Vue.$toast.open({
        message: i18n.t("pages.SimulatorPage.simulationError.toProposalErrors.submitError"),
        dismissible: true,
        type: "error",
      });
    }
  },
  async getRelationshipList({ commit }, { finId, fieldKey, query = 'RELATION_TO_PROPONENT' }) {
    try {
      const response = await fetchRelationshipList(finId, query);

      commit("setSimpleFormatDropdown", {
        data: response?.data?.data,
        type: "relationshipList-" + fieldKey,
        stateType: "proposalDropdowns",
      });

    } catch (error) {
      console.log(error);
    }
  },
  async getCountrySimpleList({ commit }, { finId, fieldKey }) {
    // destinado à dropdown de escolhas multiplas
    try {
      const isSpanish = spanishFinancials.includes(finId);
      const response = isSpanish ? await fetchSpanishCountries() : await fetchPortugueseCountries();

      commit("setCountrySimpleList", {
        data: response?.data?.data,
        type: "countrySimpleList-" + fieldKey,
        stateType: "proposalDropdowns",
        valueKey: "id",
        textKey: spanishFinancials.includes(finId) ? "nameES" : "namePT"
      });

    } catch (error) {
      console.log(error);
    }
  },
  async getCountryList({ commit, state, dispatch }, { finId, fieldKey }) {
    const isSpanish = spanishFinancials.includes(finId);
    const nationality = isSpanish ? 'ES' : 'PT';

    try {
      // ✅ 1. Se já está em cache, retorna imediatamente
      if (state.countriesCache[nationality]) {
        console.log(`[Cache Hit] ${fieldKey} - Usando cache ${nationality}`);
        
        commit("setCountryList", {
          data: state.countriesCache[nationality],
          type: "countryList-" + fieldKey,
          stateType: "proposalDropdowns",
          valueKey: "id",
          textKey: isSpanish ? "nameES" : "namePT"
        });
        
        return;
      }

      // ✅ 2. Se está carregando, aguarda e tenta novamente (recursivo)
      if (state.countriesLoading[nationality]) {
        console.log(`[Waiting] ${fieldKey} - Aguardando carregamento ${nationality}...`);
          
        await new Promise(resolve => setTimeout(resolve, 100));
          
        // Chama novamente (vai cair no cache ou aguardar mais)
        return dispatch('getCountryList', { finId, fieldKey });
      }
      
      //✅ 3. Marca como carregando
      console.log(`[Loading] ${fieldKey} - Iniciando carregamento ${nationality}...`);
      state.countriesLoading[nationality] = true;
      try {
        const response = isSpanish ? await fetchSpanishCountries() : await fetchPortugueseCountries();
        const countries = response?.data?.data;
        
        // Armazena no cache
        console.log(`[Cache Set] ${countries?.length} países armazenados`);
        await commit('setCountriesCache', { nationality, data: countries });

        commit("setCountryList", {
          data: countries,
          type: "countryList-" + fieldKey,
          stateType: "proposalDropdowns",
          valueKey: "id",
          textKey: isSpanish ? "nameES" : "namePT"
        });
      } finally {
        // ✅ 4. Sempre desbloqueia
        state.countriesLoading[nationality] = false;
      }
    } catch (error) {
      console.error('Erro ao carregar países:', error);
    
      // Garante desbloqueio em caso de erro
      const nationality = spanishFinancials.includes(finId) ? 'ES' : 'PT';
      state.countriesLoading[nationality] = false;
    }
  },
  async getNationalityRegimeList({ commit }, { fieldKey }) {
    try {
      const response = await fetchNationalityRegime();

      commit("setSimpleFormatDropdown", {
        data: response?.data?.data,
        type: "nationalityRegime-" + fieldKey,
        stateType: "proposalDropdowns",
      });

    } catch (error) {
      console.log(error);
    }
  },
  async getEmissionBi({ commit }, { fieldKey }) {
    try {
      const response = await fetchEmissionBi();

      commit("setSimpleFormatDropdown", {
        data: response?.data?.data,
        type: "emissionBi-" + fieldKey,
        stateType: "proposalDropdowns",
      });

    } catch (error) {
      console.log(error);
    }
  },
  async getMaritalStatus({ commit }, { finId, fieldKey }) {
    try {
      const response = await fetchMaritalStatus(finId);

      commit("setSimpleFormatDropdown", {
        data: response?.data?.data,
        type: "maritalStatus-" + fieldKey,
        stateType: "proposalDropdowns",
      });

    } catch (error) {
      console.log(error);
    }
  },
  async getMarriageTypes({ commit }, { finId, fieldKey }) {
    try {
      console.log(finId);
      const response = await fetchMarriageTypes();

      commit("setSimpleFormatDropdown", {
        data: response?.data?.data,
        type: "marriageTypes-" + fieldKey,
        stateType: "proposalDropdowns",
      });

    } catch (error) {
      console.log(error);
    }
  },
  async getStreetTypes({ commit }, { finId, fieldKey }) {
    try {
      const response = await fetchStreetTypes(finId);

      commit("setSimpleFormatDropdown", {
        data: response?.data?.data,
        type: "streetTypes-" + fieldKey,
        stateType: "proposalDropdowns",
      });

    } catch (error) {
      console.log(error);
    }
  },
  async getLegalType({ commit }, { fieldKey }) {
    try {
      const response = await fetchLegalType();

      commit("setSimpleFormatDropdown", {
        data: response?.data?.data,
        type: "legalType-" + fieldKey,
        stateType: "proposalDropdowns",
      });

    } catch (error) {
      console.log(error);
    }
  },
  async getStructureType({ commit }, { fieldKey }) {
    try {
      const response = await fetchStructureType();

      commit("setSimpleFormatDropdown", {
        data: response?.data?.data,
        type: "structureType-" + fieldKey,
        stateType: "proposalDropdowns",
      });

    } catch (error) {
      console.log(error);
    }
  },
  async getActivityType({ commit }, { fieldKey }) {
    try {
      const response = await fetchActivityType();

      commit("setSimpleFormatDropdown", {
        data: response?.data?.data,
        type: "activityType-" + fieldKey,
        stateType: "proposalDropdowns",
      });

    } catch (error) {
      console.log(error);
    }
  },
  async getCAE({ commit }, { fieldKey }) {
    try {
      const response = await fetchCae();

      commit("setCae", {
        data: response?.data?.data,
        type: "cae-" + fieldKey,
        stateType: "proposalDropdowns",
      });

    } catch (error) {
      console.log(error);
    }
  },
  async getCaeByFin({ commit }, { finId, fieldKey }) {
    try {
      const response = await fetchCaeByFin(finId);

      commit("setSimpleFormatDropdown", {
        data: response?.data?.data,
        type: "cae-" + fieldKey,
        stateType: "proposalDropdowns",
      });

    } catch (error) {
      console.log(error);
    }
  },
  async getResidenceTypes({ commit }, { finId, fieldKey }) {
    try {
      const response = await fetchResidenceType(finId);

      commit("setSimpleFormatDropdown", {
        data: response?.data?.data,
        type: "residenceTypes-" + fieldKey,
        stateType: "proposalDropdowns",
      });

    } catch (error) {
      console.log(error);
    }
  },
  async getSickLeaveReason({ commit }, { fieldKey }) {
    try {
      const response = await fetchSickLeaveReason();

      commit("setSimpleFormatDropdown", {
        data: response?.data?.data,
        type: "sickLeaveReason-" + fieldKey,
        stateType: "proposalDropdowns",
      });

    } catch (error) {
      console.log(error);
    }
  },
  async getIncomeTypes({ commit }, { finId, fieldKey, clientType }) {
    try {
      const response = await fetchIncomeType(finId);
      const responseData = response?.data?.data
      if (clientType == 4 && finId === 15) {
        const noDesiredElements = ["Nomina"];
        const independentArray = responseData?.filter((data) => !noDesiredElements?.includes(data));
        commit("setSimpleFormatDropdown", {
          data: independentArray,
          type: "jobStatus-" + fieldKey,
          stateType: "proposalDropdowns",
        });
      }else{
        commit("setSimpleFormatDropdown", {
          data: responseData,
          type: "incomeType-" + fieldKey,
          stateType: "proposalDropdowns",
        });
      }
    } catch (error) {
      console.log(error);
    }
  },
  async getJobCategory({ commit }, { finId, fieldKey, clientType }) {
    try {
      const response = await fetchJobCategory(finId);
      const responseData = response?.data?.data

      //Categoria profissional Credibom - caso seja ENI só deve permitir categoria ENI
      if (clientType === 2 && finId === 9) {
        const desiredElements = ['Empresario Agricola', 'E.N.I.', 'Comerciante', 'Profissao liberal'];
        const eniArray = responseData?.filter((data) => desiredElements?.includes(data));
        commit("setSimpleFormatDropdown", {
          data: eniArray,
          type: "jobCategory-" + fieldKey,
          stateType: "proposalDropdowns",
        });
      } else if (clientType === 4 && (finId === 12 || finId === 13)) {
        const desiredElements = ['Autónomo', 'Profesión liberal/Freelance'];
        const independentArray = responseData?.filter((data) => desiredElements?.includes(data));
        commit("setSimpleFormatDropdown", {
          data: independentArray,
          type: "jobCategory-" + fieldKey,
          stateType: "proposalDropdowns",
        });
      } else if (clientType === 4 && finId === 16) {
        const desiredElements = ["Trabajador por cuenta propia", "Rentista"];
        const independentArray = responseData?.filter((data) => desiredElements?.includes(data));
        commit("setSimpleFormatDropdown", {
          data: independentArray,
          type: "jobCategory-" + fieldKey,
          stateType: "proposalDropdowns",
        });
      } else if (clientType === 1 && finId === 16) {
        const noDesiredElements = ["Trabajador por cuenta propia"];
        const independentArray = responseData?.filter((data) => !noDesiredElements?.includes(data));
        commit("setSimpleFormatDropdown", {
          data: independentArray,
          type: "jobCategory-" + fieldKey,
          stateType: "proposalDropdowns",
        });
      } else if (clientType !== 4 && finId === 15) {
        const noDesiredElements = ["Autónomo"];
        const independentArray = responseData?.filter((data) => !noDesiredElements?.includes(data));
        commit("setSimpleFormatDropdown", {
          data: independentArray,
          type: "jobCategory-" + fieldKey,
          stateType: "proposalDropdowns",
        });
      } else if (clientType === 4 && finId === 15) {
        const desiredElements = ["Autónomo"];
        const independentArray = responseData?.filter((data) => desiredElements?.includes(data));
        commit("setSimpleFormatDropdown", {
          data: independentArray,
          type: "jobCategory-" + fieldKey,
          stateType: "proposalDropdowns",
        });
      } else if (clientType === 4 && finId === 17) {
        const desiredElements = ["Autonomo"];
        const independentArray = responseData?.filter((data) => desiredElements?.includes(data));
        commit("setSimpleFormatDropdown", {
          data: independentArray,
          type: "jobCategory-" + fieldKey,
          stateType: "proposalDropdowns",
        });
      } else if (clientType !== 4 && finId === 17) {
        const noDesiredElements = ["Autonomo"];
        const independentArray = responseData?.filter((data) => !noDesiredElements?.includes(data));
        commit("setSimpleFormatDropdown", {
          data: independentArray,
          type: "jobCategory-" + fieldKey,
          stateType: "proposalDropdowns",
        });
      } else {
        commit("setSimpleFormatDropdown", {
          data: responseData,
          type: "jobCategory-" + fieldKey,
          stateType: "proposalDropdowns",
        });
      }

    } catch (error) {
      console.log(error);
    }
  },
  async getJobStatus({ commit }, { finId, fieldKey, clientType }) {
    try {
      const response = await fetchJobStatus(finId);

      // Financeiras PT, que não Credibom nem Cetelem, nem Santander: Situação profissional disponível, de acordo com o tipo de cliente
      // https://dtogsc.atlassian.net/browse/SIFA-1171
      if (finId !== 8 && finId !== 9 && finId !== 4) {
        // ENI  
        if (clientType === 2) {
          const responseData = response?.data?.data
          const desiredElements = ['Empresário', 'Recibos Verdes'];
          const eniArray = responseData?.filter((data) => desiredElements?.includes(data));
          commit("setSimpleFormatDropdown", {
            data: eniArray,
            type: "jobStatus-" + fieldKey,
            stateType: "proposalDropdowns",
          });
        } else if (clientType === 4 && (finId === 12 || finId === 13)) {//Autónomo - BBVA ES E Sofinco
          const responseData = response?.data?.data
          const desiredElements = ['Autónomo', 'Profesión liberal/Freelance'];
          const eniArray = responseData?.filter((data) => desiredElements?.includes(data));
          commit("setSimpleFormatDropdown", {
            data: eniArray,
            type: "jobStatus-" + fieldKey,
            stateType: "proposalDropdowns",
          });
        } else if (clientType !== 4 && finId === 15) {
          const responseData = response?.data?.data
          const noDesiredElements = ["Autonomo"];
          const independentArray = responseData?.filter((data) => !noDesiredElements?.includes(data));
          commit("setSimpleFormatDropdown", {
            data: independentArray,
            type: "jobStatus-" + fieldKey,
            stateType: "proposalDropdowns",
          });
        }
        // Restantes
        else {
          const responseData = response?.data?.data
          const desiredElements = ['Empresário', 'Recibos Verdes'];
          const eniArray = responseData?.filter((data) => !desiredElements?.includes(data));
          commit("setSimpleFormatDropdown", {
            data: eniArray,
            type: "jobStatus-" + fieldKey,
            stateType: "proposalDropdowns",
          });
        }
        return;
      }
      //Credibom & Cetelem
      commit("setSimpleFormatDropdown", {
        data: response?.data?.data,
        type: "jobStatus-" + fieldKey,
        stateType: "proposalDropdowns",
      });

    } catch (error) {
      console.log(error);
    }
  },
  async getJobs({ commit }, { finId, fieldKey, clientType }) {
    try {
      const response = await fetchJobs(finId);

      if (clientType !== 4 && finId === 15) {
        const responseData = response?.data?.data
        const noDesiredElements = ["Autonomo"];
        const independentArray = responseData?.filter((data) => !noDesiredElements?.includes(data));
        commit("setSimpleFormatDropdown", {
          data: independentArray,
          type: "jobs-" + fieldKey,
          stateType: "proposalDropdowns",
        });
        return;
      }

      commit("setSimpleFormatDropdown", {
        data: response?.data?.data,
        type: "jobs-" + fieldKey,
        stateType: "proposalDropdowns",
      });

    } catch (error) {
      console.log(error);
    }
  },
  async getIdentificationDocumentType({ commit }, { finId, fieldKey }) {
    try {
      const response = await fetchIdDocumentTypes(finId);

      commit("setSimpleFormatDropdown", {
        data: response?.data?.data,
        type: "identificationDocumentType-" + fieldKey,
        stateType: "proposalDropdowns",
      });

    } catch (error) {
      console.log(error);
    }
  },
  async getJobsWithCategory({ commit, state }, { finId, jobCategory, fieldKey }) {
    try {
      const response = await fetchJobsWithCategory(finId, jobCategory);
      commit("setSimpleFormatDropdown", {
        data: response?.data?.data,
        type: "jobsWithCategory-" + fieldKey,
        stateType: "proposalDropdowns",
      });

      return state["proposalDropdowns"][`jobsWithCategory-${fieldKey}`];
    } catch (error) {
      console.log(error);
    }
  },
  async getCompanySector({ commit }, { finId, fieldKey }) {
    try {
      const response = await fetchCompanySector(finId);

      commit("setSimpleFormatDropdown", {
        data: response?.data?.data,
        type: "companySector-" + fieldKey,
        stateType: "proposalDropdowns",
      });

    } catch (error) {
      console.log(error);
    }
  },
  async getInterventionType({ commit, state }, { fieldKey }) {
    try {
      let data = [];
      if (state.proposalFinId === FINANCIAL_IDS.COFIDIS_PT && fieldKey !== "interventionType") {//Cofidis - Proposta PT - Tipos de intervenção são dinâmicos e vêm da API
        const response = await fetchRelationshipList(state.proposalFinId, "INTERVENTION_TYPE");
        data = response?.data?.data || [];
      }

      commit("setInterventionTypeByKey", {
        data: data,
        fieldKey: fieldKey,
        stateType: "proposalDropdowns",
      });

    } catch (error) {
      console.log(error);
    }
  },
  async getNumberOfPayments({ commit }, { fieldKey }) {
    try {
      commit("setNumberOfPayments", {
        fieldKey: fieldKey,
        stateType: "proposalDropdowns",
      });

    } catch (error) {
      console.log(error);
    }
  },
  async getPatrimonyValue({ commit }, { fieldKey }) {
    try {
      commit("setPatrimonyValue", {
        fieldKey: fieldKey,
        stateType: "proposalDropdowns",
      });

    } catch (error) {
      console.log(error);
    }
  },
  async getResidencePermitTypes({ commit }, { fieldKey }) {
    try {
      commit("setResidencePermitTypes", {
        fieldKey: fieldKey,
        stateType: "proposalDropdowns",
      });

    } catch (error) {
      console.log(error);
    }
  },
  async getPublicPositionList({ commit }, { fieldKey }) {
    try {
      //const response = await fetchPublicPositions(); // nova chamada API
      //data: response?.data?.data,  // substitui o fallback estático
      commit("setPublicPositionList", {
        fieldKey: fieldKey,
        stateType: "proposalDropdowns",
      });
    } catch (error) {
      console.log(error);
    }
  },
  async submitProposal({ commit, rootGetters }) {
    commit("setTableLoading", false);
    try {
      const entityId = rootGetters["AuthenticationModule/getUserEntityId"];
      //TODO: Mudar o payload - temporário
      const payload = {
        "idProposal": state.proposalId,
        "idCurrentEntity": entityId,
        "gscCode": state.proposalGSCCode,
        "selFinancialReason": "string"
      };

      const response = await submitProposal(payload);
      console.log(response);
      Vue.$toast.open({
        message:
          response.status == 200 ? i18n.t("pages.SimulatorPage.simulationError.toProposalSuccess.success") : response?.response?.data?.data,
        dismissible: true,
        type: response.status == 200 ? "success" : "error",
      });

      return response.status;

    } catch (error) {
      Vue.$toast.open({
        message: i18n.t("pages.SimulatorPage.simulationError.toProposalErrors.submitError"),
        dismissible: true,
        type: "error",
      });
    }
  },
  async fetchDocumentTypes({ commit }, { idProposal, formNationality, idClientType }) {
    try {
      const response = await fetchDocumentsTypes(idProposal, formNationality, idClientType);
      commit("setDocumentTypesDropdown", {
        data: response?.data?.data,
        type: "documentTypes",
        stateType: "proposalDropdowns"
      });
      commit("setDocumentTypesArray", response?.data?.data);
    } catch (error) {
      console.log(error);
    }
  },
  async fetchDocumentList({ commit }, proposalId) {
    try {
      const response = await fetchDocumentList(proposalId);
      commit("setDocumentsList", response?.data?.data?.documents);

      return response?.data?.data?.documents;
    } catch (error) {
      console.log(error);
    }
  },
  async downloadDocument({ commit }, requestData) {
    commit("setTableLoading", false);
    try {
      const response = await downloadDocument(requestData);
      downloadFile(response.data, requestData?.documentName);
    } catch (error) {
      Vue.$toast.open({
        message: i18n.t("form.error.downloadError"),
        dismissible: true,
        type: "error",
      });
    }
  },
  async deleteDocument({ commit }, requestData) {
    commit("setTableLoading", false);
    try {
      const response = await deleteDocument(requestData);
      console.log(response)
    } catch (error) {
      Vue.$toast.open({
        message: i18n.t("form.error.deleteDocumentError"),
        dismissible: true,
        type: "error",
      });
    }
  },
  async updateProposal({ commit }, { idProposal, documentType, base64File, clientCategory, filename }) {
    commit("setTableLoading", false);
    try {
      
      const response = await uploadDocument({ idProposal, documentType, base64File, clientCategory, filename });
      return response;
    } catch (error) {
      Vue.$toast.open({
        message: i18n.t("pages.SimulatorPage.simulationError.toProposalErrors.submitError"),
        dismissible: true,
        type: "error",
      });
    }
  },
  async proposalDigitalSignature({ commit }) {
    commit("setTableLoading", false);
    try {
      const response = await proposalDigitalSignature(state.proposalId);
      return response;
    } catch (error) {
      Vue.$toast.open({
        message: i18n.t("pages.SimulatorPage.simulationError.toProposalErrors.digitalSignatureError"),
        dismissible: true,
        type: "error",
      });
    }
  },
  async getSearchByPostalCode({ commit }, { localityFieldKey, postalCode, formNationality }) {
    try {
      const response = await getSearchByPostalCode({ postalCode, formNationality });

      commit("setPostalCodeFormatDropdown", {
        data: response?.data?.data,
        localityType: "locality-" + localityFieldKey,
        stateType: "proposalDropdowns",
      });

      return { districtValue: response?.data?.data?.district, municipalityValue: response?.data?.data?.municipality };

    } catch (error) {
      console.log(error);
    }
  },
  async duplicateProposal({ commit }, payload) {
    commit("setTableLoading", false);
    try {
      await duplicateProposal(payload);
    } catch (error) {
      console.log(error);
    }
  },
  async forfeitProposal({ commit }, payload) {
    commit("setTableLoading", false);
    try {
      const response = await forfeitProposal(payload);
      return response;
    } catch (error) {
      console.log(error);
    }
  },
  async credibomDigitalSignature({ commit }, payload) {
    commit("setTableLoading", false);
    try {
      const response = await credibomDigitalSignature(payload);
      return response;
    } catch (error) {
      console.log(error);
    }
  },
  async ptDigitalSignature({ commit }, queryParams) {
    commit("setTableLoading", false);
    try {
      const response = await ptDigitalSignature(queryParams);
      return response?.data?.data;
    } catch (error) {
      console.log(error);
    }
  },
  async bpiProposalDocDownload({ commit }, queryParams) {
    commit("setTableLoading", false);
    try {
      const response = await bpiProposalDocDownload(queryParams);
      downloadFile(response.data, "Folha de proposta");
    } catch (error) {
      console.log(error);
    }
  },
  async proposalLogsDownload({commit}, idProposal) {
    commit("setTableLoading", false);
    try {
      const response = await getProposalLogs(idProposal);
      downloadFile(response.data, "logs-"+idProposal);
    } catch (error) {
      console.log(error);
    }
  },
  async verifyVideoIdentification({ commit }, payload) {
    commit("setTableLoading", false);
    try {
      const response = await videoIdentificationProcess(payload);
      return response;
    } catch (error) {
      console.log(error);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
